export default "assets/images/icons/slider-arrow-547f9d64.svg";